import { useEffect, useMemo, useState } from "react";

export const useLiveDateTime = () => {
  const [dateTime, setDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Format date as DD/MM/YYYY and time as HH:MM:SS
  const formatDateTime = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const formattedDateTime = useMemo(() => {
    return formatDateTime(dateTime);
  }, [dateTime]);

  return {
    dateTime,
    formatDateTime,
    formattedDateTime,
  };
};
